import React from 'react';
import { Typography, Row, Col, Image, Divider } from 'antd';
import '../../../Styles/ResearchLabs.css';  // Import the CSS for styling
import scopeImage from '../../../Assets/ResearchLabs/SARL/SARL-Circular.jpg';

const { Title, Paragraph } = Typography;

const Scope = () => {
  return (
    <section className="sarl-scope-section">
      <div className="sarl-scope-inner">
        <Row gutter={[72, 40]} align="middle" justify="space-between">
          <Col xs={24} md={15}>
            <Title level={2} className="sarl-scope-title">Scope</Title>
            <Divider className="ncgsa-divider" />
            <Paragraph className="sarl-scope-description">
            The Space and Astrophysics Research Lab aims to develop the field of astronomy and astrophysics in Pakistan. The study of space, the Universe, stars, galaxies and various other astrophysical phenomena is centuries old endeavor and has been intertwined with the development of human societies. Astronomy and astrophysics is currently in a golden age with the development of new observatories, theoretical understanding and growing computational resources. However, in Pakistan, this area of research is next to non-existent and we aim to develop it through the following domains.
            </Paragraph>
          </Col>
          <Col xs={24} md={9}>
            <div className="sarl-scope-image-wrap">
              <Image src={scopeImage} alt="Space and astrophysics research" className="sarl-scope-image" preview={false} />
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default Scope;
